import Box from '@mui/material/Box'

export default function ListAction({ children }) {
  return (
    <Box
      sx={{
        display: 'flex',
        pt: { xs: 3, sm: 4 },
        pr: { xs: 2, sm: 4 },
        pb: { xs: 4, sm: 0 },
        pl: { xs: 2, sm: 4 },
        mb: -2,
      }}
    >
      <div style={{ flex: 1 }} />
      {children}
    </Box>
  )
}
